import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPoisLoadingFailed,
  getPoisDeleteSuccess,
  getPoisDeleteFailed,
  getPoiUpdateSuccess,
  getPoiUpdateFailed,
  getSelectedCustomPoiIds,
  getPoiPreferenceUpdateSuccess,
  getPoiPreferenceUpdateFailed
} from '../../../redux/selectors/poiAdmin';
import {
  showErrorNotification,
  showSuccessNotification
} from '../../../helpers/globalNotifications';
import {
  setPoisLoadingFailed,
  setPoisDeleteFailed,
  setPoisDeleteSuccess,
  setSelectedCustomPoiIds,
  setPoiUpdateSuccess,
  setPoiUpdateFailed,
  setPoiPreferenceUpdateSuccess,
  setPoiPreferenceUpdateFailed
} from '../../../redux/slice/poiAdmin/poiAdmin';

const PoiNotificationsContainer = () => {
  const dispatch = useDispatch();
  const poisLoadingFailed = useSelector(getPoisLoadingFailed);
  const poisDeleteSuccess = useSelector(getPoisDeleteSuccess);
  const poisDeleteFailed = useSelector(getPoisDeleteFailed);
  const poiUpdateSuccess = useSelector(getPoiUpdateSuccess);
  const poiUpdateFailed = useSelector(getPoiUpdateFailed);
  const poiPreferenceUpdateSuccess = useSelector(getPoiPreferenceUpdateSuccess);
  const poiPreferenceUpdateFailed = useSelector(getPoiPreferenceUpdateFailed);
  const selectedCustomPoiIds = useSelector(getSelectedCustomPoiIds);

  useEffect(() => {
    if (poisLoadingFailed) {
      showErrorNotification('Failed to load locations');
      dispatch(setPoisLoadingFailed(false));
    }
  }, [poisLoadingFailed, dispatch]);

  useEffect(() => {
    if (poisDeleteFailed) {
      showErrorNotification('Failed to delete locations');
      dispatch(setPoisDeleteFailed(false));
    }
  }, [poisDeleteFailed, dispatch]);

  useEffect(() => {
    if (poisDeleteSuccess) {
      showSuccessNotification(
        `Selected ${selectedCustomPoiIds.length > 1 ? 'locations' : 'location'} deleted`
      );
      dispatch(setPoisDeleteSuccess(false));
      dispatch(setSelectedCustomPoiIds([]));
    }
  }, [poisDeleteSuccess, selectedCustomPoiIds, dispatch]);

  useEffect(() => {
    if (poiUpdateSuccess) {
      showSuccessNotification('Location updated');
      dispatch(setPoiUpdateSuccess(false));
    }
  }, [poiUpdateSuccess, dispatch]);

  useEffect(() => {
    if (poiUpdateFailed) {
      showErrorNotification('Failed to update location');
      dispatch(setPoiUpdateFailed(false));
    }
  }, [poiUpdateFailed, dispatch]);

  useEffect(() => {
    if (poiPreferenceUpdateSuccess) {
      showSuccessNotification('Location preferences updated');
      dispatch(setPoiPreferenceUpdateSuccess(false));
    }
  }, [poiPreferenceUpdateSuccess, dispatch]);

  useEffect(() => {
    if (poiPreferenceUpdateFailed) {
      showErrorNotification('Failed to update location preferences');
      dispatch(setPoiPreferenceUpdateFailed(false));
    }
  }, [poiPreferenceUpdateFailed, dispatch]);

  return <></>;
};

export default PoiNotificationsContainer;
